export const calculateCompletePercentage = (need, have) => {
  if (!need) {
    return have > 0 ? "100.00" : "0.00";
  }
  const percentage = (have / need) * 100;
  console.log("percentage complete", percentage);
  return parseFloat(percentage).toFixed(2);
};
const calculateIncompletePercentage = (need, have) => {
  let percentage = (have / need) * 100;
  percentage = 100 - percentage;
  console.log("percentage incomeplete", percentage);
  return parseFloat(percentage).toFixed(2);
};

// const getMonthsDifference = (date1, date2) => {
//   const year1 = date1.getFullYear();
//   const year2 = date2.getFullYear();
//   const month1 = date1.getMonth();
//   const month2 = date2.getMonth();

//   return (year2 - year1) * 12 + (month2 - month1);
// };
function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }
function getTotalAmountUseForGoal(input) {
  if (Array.isArray(input)) {
    if (input.length === 0) return 0;

    if (typeof input[0] === "number") {
      // Case 1: Array of numbers
      return input.reduce((acc, val) => acc + val, 0);
    }

    if (typeof input[0] === "object" && input[0] !== null) {
      // Case 2: Array of objects with amountUseForGoal
      return input.reduce(
        (acc, obj) => acc + parseFloat(obj.amountUseForGoal || 0),
        0
      );
    }
  } else if (typeof input === "object" && input !== null) {
    // Case 3: Single object with amountUseForGoal
    return parseFloat(input.amountUseForGoal || 0);
  }

  return 0; // fallback if input is invalid
}

const calculateGoalNeed = (amountNeed, date, inflationRate) => {
  const GoalNeedToday = amountNeed ? amountNeed : 0;
  // const GoalInflationRate = data["Inflation rate for this goal"]
  //   ? data["Inflation rate for this goal"] / 100
  //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
  const GoalInflationRate = inflationRate || 0;
  let GoalDate = date ? new Date(date) : new Date();
  if (!(GoalDate instanceof Date)) {
    GoalDate = new Date(GoalDate);
  }
  const todaysDate = new Date();
  const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
  if (!(GoalDate instanceof Date)) {
    GoalDate = new Date(GoalDate);
  }
  // Calculate the number of days between GoalDate and todaysDate
  const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
  // Calculate the formula
  // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
  const result =
    GoalNeedToday *
    Math.pow(
      1 + GoalInflationRate / 100 / 365,
      365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
        NumberofMonths
    );
  console.log("result", result);
  return parseFloat(result).toFixed(2);
};

export const calculateSavingsForGoal = (goal, asset,taxInfo) => {
  const goalDate = goal["Goal Date"] ? new Date(goal["Goal Date"]) : new Date();
  console.log("goaaaaaa", goal, asset);
  const amountNeedToday = parseFloat(goal["Dollar Amount Needed"] || 0);
  const goalInflationRate = parseFloat(
    goal["Inflation Rate for this Goal"] || 0
  );
  const goalInflation = goal && goal["Inflation rate for this goal"];

  const matchedInflation =
      taxInfo &&
      taxInfo.find((item) => item.name === goalInflation);

  // Step 1: Calculate future value of goal amount (inflated)
  console.log("matttttt",matchedInflation,amountNeedToday,goalDate)
  const goalNeedAtGoalDate = parseFloat(
    calculateGoalNeed(amountNeedToday, goalDate, matchedInflation && matchedInflation.value ? matchedInflation.value : 0)
  );

  // Step 2: Calculate total "have" amount
  //   const assignAssetValue = Array.isArray(goal.assignAssets)
  //     ? goal.assignAssets.reduce(
  //         (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
  //         0
  //       )
  //     : 0;
  const assignAssetValue = getTotalAmountUseForGoal(
    goal.amountUseForGoal || goal.assignAssets
  );

  const amountReceivedFromFriends = Array.isArray(goal["Amount Received"])
    ? goal["Amount Received"].reduce(
        (acc, curr) => acc + parseFloat(curr || 0),
        0
      )
    : 0;

  const totalHaveAmount = assignAssetValue + amountReceivedFromFriends;

  // Step 3: Calculate "new need" (K8)
  const numberOfMonths = getMonthsDifference(new Date(), goalDate); // D8
  // const newNeed = goalNeedAtGoalDate - totalHaveAmount;
  const b7 = amountNeedToday - totalHaveAmount;
  const b8 = matchedInflation && matchedInflation.value ? matchedInflation.value / 100 : 0;
  const b4 = numberOfMonths;
  console.log("bbbbb",b7,b8,b4)

  const newNeed = b7 * Math.pow((1 + (b8 / 12)), b4);

  // Step 4: Get asset rate of return (D17) and months remaining (D8)
  const annualRate = asset && parseFloat(asset["Static"] || 0) || 0; // Annual Rate in percent
  //   const annualRate = parseFloat(asset["Inflation Rate for this Goal"] || 0); // Annual Rate in percent

  const monthlyRate = annualRate === 0 ? 0 : annualRate / 100 / 12; // Decimal monthly rate

  // Step 5: Apply the Excel formula
  let monthlySavingRequired = 0;

  if (monthlyRate === 0) {
    // If rate is 0, avoid division by 0
    monthlySavingRequired = numberOfMonths === 0 ? 0 : newNeed / numberOfMonths;
  } else {
    console.log("here in my formulaa",newNeed,monthlyRate,numberOfMonths,totalHaveAmount,goalNeedAtGoalDate )
    const numerator = newNeed * monthlyRate;
    const denominator = Math.pow(1 + monthlyRate, numberOfMonths) - 1;
    monthlySavingRequired = numerator / denominator;
  }
  const monthlySavingwithZeroRateofReturn =  numberOfMonths === 0 ? 0 : newNeed / numberOfMonths;
  const actualMonthlySaving = goal["Actual Monthly Savings"] || 0;
  const futureMonthlySaving = actualMonthlySaving * numberOfMonths;
  const totalhaveTillGoalDate = futureMonthlySaving + totalHaveAmount;
  
  let actualMonthlySavingAmount;

  if (annualRate === 0) {
    // If annual rate is zero, it's just monthly saving × number of months
    actualMonthlySavingAmount = actualMonthlySaving * numberOfMonths;
  } else {
    actualMonthlySavingAmount = actualMonthlySaving * (
      (Math.pow(1 + (annualRate / 100) / 12, numberOfMonths) - 1) /
      ((annualRate / 100) / 12)
    );
  }
  const percentageFunded = calculateCompletePercentage(
    goalNeedAtGoalDate,
    totalHaveAmount + (actualMonthlySavingAmount ? actualMonthlySavingAmount : 0)
  );
  // console.log(
  //   "Monthly Saving Required:",
  //   annualRate,
  //   actualMonthlySavingAmount,
  //   monthlySavingRequired,
  //   monthlySavingwithZeroRateofReturn,
  //   actualMonthlySaving,
  //   futureMonthlySaving,
  //   totalhaveTillGoalDate,
  //   goalNeedAtGoalDate,
  //   percentageFunded
  // );
  return{
    monthlySavingRequired,
    monthlySavingwithZeroRateofReturn,
    actualMonthlySaving,
    futureMonthlySaving: actualMonthlySavingAmount,
    totalhaveTillGoalDate,
    goalNeedAtGoalDate,
    newTotalNeed: newNeed-actualMonthlySavingAmount,
    percentageFunded
  }
  return parseFloat(monthlySavingRequired.toFixed(2));
};

export const calculateGoalDifferences = (goal) => {

  const housingCurrent = parseFloat(goal["Housing (Rent/Mortgage) Current"] || 0);
  const housingProposed = parseFloat(
    goal["Housing (Rent/Mortgage) Proposed"] || 0
  );
  const transportationCurrent = parseFloat(
    goal["Transportation Current"] || 0
  );
  const transportationProposed = parseFloat(
    goal["Transportation Proposed"] || 0
  );
  const groceriesCurrent = parseFloat(goal["Groceries Current"] || 0);
  const groceriesProposed = parseFloat(goal["Groceries Proposed"] || 0);
  const utilitiesCurrent = parseFloat(goal["Utilities Current"] || 0);
  const utilitiesProposed = parseFloat(goal["Utilities Proposed"] || 0);
  const salaryCurrent = parseFloat(goal["Salary Current"] || 0);
  const salaryProposed = parseFloat(goal["Salary Proposed"] || 0);
  const housingDifference = housingCurrent - housingProposed;
  const transportationDifference = transportationCurrent - transportationProposed;
  const groceriesDifference = groceriesCurrent - groceriesProposed;
  const utilitiesDifference = utilitiesCurrent - utilitiesProposed;
  const salaryDifference = salaryProposed - salaryCurrent;
  const housingPercentage = housingCurrent === 0 ? 0 : (housingDifference / housingCurrent) * 100;
  const transportationPercentage = transportationCurrent === 0 ? 0 : (transportationDifference / transportationCurrent) * 100;
  const groceriesPercentage = groceriesCurrent === 0 ? 0 : (groceriesDifference / groceriesCurrent) * 100;
  const utilitiesPercentage = utilitiesCurrent === 0 ? 0 : (utilitiesDifference / utilitiesCurrent) * 100;
  const salaryPercentage = salaryCurrent === 0 ? 0 : (salaryDifference / salaryCurrent) * 100;
  return {
    housingDifference: housingDifference.toFixed(2),
    transportationDifference: transportationDifference.toFixed(2),
    groceriesDifference: groceriesDifference.toFixed(2),
    utilitiesDifference: utilitiesDifference.toFixed(2),
    salaryDifference: salaryDifference.toFixed(2),
    housingPercentage: housingPercentage.toFixed(2),
    transportationPercentage: transportationPercentage.toFixed(2),
    groceriesPercentage: groceriesPercentage.toFixed(2),
    utilitiesPercentage: utilitiesPercentage.toFixed(2),
    salaryPercentage: salaryPercentage.toFixed(2),
  };
}